import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[wtValidateOnBlur]',
})
export class WtValidateOnBlurDirective {
  private control = inject(NgControl);

  @HostListener('blur') onBlur() {
    this.control.control?.updateValueAndValidity();
  }
}
